import { TrackSourceType } from "../model/tracks";
import { AudioSource } from "./routing";

export abstract class RydInputSource {
    constructor(
        public name: string,
        public id: string,
        public type: TrackSourceType
    ) {}

    getdisplayName(): string {
        return this.name;
    }
}

export class RydMidiInputSource extends RydInputSource {
    constructor(name: string, id: string, public midiInput?: AudioSource) {
        super(name, id, 'MIDIIN');
    }
}

export class RydManualInputSource  extends RydInputSource {
    constructor() {
        super('Manual Note Input', 'manual-note-input', 'MANUAL');
    }
}

// FIXME: do we need to represent a track as loop?
// export class RydLoopInputSource extends RydInputSource {
//     constructor() {
//         super('Loopback Input', 'loopback-input', 'LOOP');
//     }
// }